import ShadowChat from './Main/Main';
import Themes from './lib/theme/Themes';
import scConfig from './config';

export interface IConfiguration {
    themeManagerEnabled: boolean,
    path: string,
    component: typeof ShadowChat,
    prefix: string,
    defaultTheme: Themes,
    alternateTheme: Themes,
    showOverlayLink: boolean,
    withThemeSelect: boolean,
    config: typeof scConfig,
}

export const configuration: IConfiguration = {
    themeManagerEnabled: true,
    path: "/shadow-chat",
    component: ShadowChat,
    prefix: "sc",
    defaultTheme: Themes.SOMNIWORKS_THEME,
    alternateTheme: Themes.PINK_THEME,
    showOverlayLink: true,
    withThemeSelect: false,
    config: scConfig,
};
